import { FC } from 'react';
import { Form, Input } from 'antd';
import { FormInputProps } from './ts-config';

const FormInput: FC<FormInputProps> = ({
  label,
  name,
  rules = [],
  placeholder = `请输入${label || ''}`,
  maxLength,
  onClickInput,
  prefix,
  allowClear = true,
  formItemConfig = {},
  config = {},
}) => {
  return (
    <Form.Item name={name} label={label} rules={rules} {...formItemConfig}>
      <Input
        maxLength={maxLength}
        prefix={prefix}
        placeholder={placeholder}
        autoComplete={config?.autoComplete || 'off'}
        allowClear={allowClear}
        {...config}
        onClick={() => onClickInput && onClickInput()}
      />
    </Form.Item>
  );
};

export default FormInput;
